import React from 'react';
import { Button } from 'react-bootstrap';
import { navigate } from 'gatsby';
import { OptimizedImage } from '../common/OptimizedImage';
import InControlSection from '../common/InControlSection';
import { isLoggedIn } from '../../services/auth.api';

const HowItWorksSection = ({ pagename }) => {

  const buttonText = isLoggedIn()
    ? 'Dashboard'
    : pagename === 'aboutPage'
      ? 'Create my furbaby meal plan'
      : 'Build your feeding plan';

  return (
    <>
      <div className="treats-3-bg">
        <div className="section-item def-w-max">
          <div className="row mgn-top-50">
            <div className="col-12 col-sm-6">
              <div className="op-img-wrap">
                <OptimizedImage fileName="hiw_img_2.png" />
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <div className="txt-wrap-sect">
                <h2 className="mgn-bot-30 sectionAlignment">What's in the box?</h2>
                <p className="para-txt">
                  Each box comes with 5KGs of our fabulous natural dog food. The
                  box includes a personalised feeding plan and a cut-out
                  cardboard scoop to help you serve just the right amount of
                  food.
                </p>
                <div className="tick-list">
                  <ul>
                    <li>
                      We’ll send you 2 or more boxes at a time if your family
                      needs more than 5kg.
                    </li>
                    <li>
                      You can adjust how much and how often your orders are
                      delivered to suit you dogs changing needs.
                    </li>
                    <li>Skip, pause, change or cancel any time you like.</li>
                  </ul>
                </div>
                <Button
                  className="btn-def mgn-top-30"
                  onClick={() =>
                    navigate(isLoggedIn() ? '/account/dashboard/' : '/getstarted/')
                  }
                >
                  {buttonText}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <InControlSection />
      {pagename !== 'aboutPage' ? (
        <div className="section-item def-w-max no-mgn">
          <div className="row mgn-top-50">
            <div className="col-12 col-sm-6">
              <div className="op-img-wrap">
                <OptimizedImage fileName="section_img_4.png" />
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <div className="txt-wrap-sect">
                <h2 className="mgn-bot-30 sectionAlignment">
                  Never miss treat time... or a poop at the park
                </h2>
                <p className="para-txt">
                  Show a little extra love with treats, and be that pet parent who
                  always has a bag to spare... with easy add-ons to your
                  subscription
                </p>
                <div className="tick-list">
                  <ul>
                    <li>
                      Add treats and/or poop bags to your regular food delivery
                      and make changes in your dashboard any time you like.
                    </li>
                    <li>100% natural NZ air dried beef liver treats</li>
                    <li>Home-compostable poop bags</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default HowItWorksSection;
